import { useEffect, useState } from "react"
import moment from "moment"
import type { SuccessFetch } from "types"
import { useApi } from "utils"

export const useBillServiceCode = () => {
  const api = useApi()
  const [data, setData] = useState<string>("")

  useEffect(() => {
    refetch() 
  
    return () => setData("")

    // eslint-disable-next-line
  }, [])

  const refetch = (): void => {
    api.post("/probill/generate_bill_service_code", { trx_date: moment().format("YYYY-MM-DD") })
    .then((res: SuccessFetch<{ payload: { next_code: string } }>) => {
      setData(res?.data?.payload?.next_code)
    })
    .catch(() => setData(""))
  }

  return { data, refetch }
}